import { Network, Picklist } from "@/types";

import { getOperator, globalConfig, headers } from "@/utils";
import { settings } from "@/settings";
import axios from "axios";
import Notify from 'quasar/src/plugins/Notify.js';;
import moment from "moment";
import { api, apiAnonymousToken } from "@/auth/api";
const api_query_url = settings.api_query_url;
const odmUser = `odm-user`;
const baseUrl = `${settings.api_url}/${odmUser}/api/1/${odmUser}`;

export function getQcSearchAuthority(filter: any, offset?: any, limit?: any): any {
  const qc_header: any = {
    qc: {
      queryId: "authority-filter-search",
      offset: offset || 0,
      limit: limit || 100,
    },
  };
  qc_header.qc.parameters = {
    ...filter,
  };
  const operators: any = [];

  if (filter && filter.authority) {
    operators.push(getOperator("lower(user_authority", "id)", "LIKE", globalConfig.formatters.getEqualValue("%" + filter.authority + "%").toLowerCase(), "id"));
  }

  if (operators.length > 0) {
    qc_header.qc.otherFilters = {
      expressions: [
        {
          and: {
            operators,
          },
        },
      ],
    };
  }

  return qc_header.qc;
}

export function searchAuthority(filter: any, offset?: any, limit?: any): Promise<any[]> {
  return new Promise<any[]>((resolve, reject) => {
    const url = settings.api_query_url;
    const qc = getQcSearchAuthority(filter, offset, limit);
    const _headers = headers({
      qc: JSON.stringify(qc),
    });
    axios
      .get(url, {
        headers: _headers,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
}

export async function createauthority(authority: any) {
  return apiAnonymousToken().post(`${baseUrl}/authority/`, authority);
}
export async function deleteAuthority(resourceUid: any) {
  return api().delete(`${baseUrl}/authority/` + resourceUid + "/");
}

export function getUserNetworks(filter: Network): Promise<Picklist> {
  return new Promise<Picklist>(async (resolve, reject) => {
    const url = settings.api_query_url;

    const qc_header: any = {
      qc: {
        queryId: "party-network-node",
      },
    };
    qc_header.qc.parameters = {
      ...filter,
    };
    const operators = [];
    if (filter && filter.user != null) {
      operators.push(getOperator("party_party_role", "party_id", "EQUAL", globalConfig.formatters.getEqualValue(filter.user), "party_id"));
    }
    if (operators.length > 0) {
      qc_header.qc.otherFilters = {
        expressions: [
          {
            and: {
              operators,
            },
          },
        ],
      };
      qc_header.qc.otherOrders = null;
      qc_header.qc.offset = 0;
      qc_header.qc.limit = 50;
    }

    const _headers = headers({
      qc: JSON.stringify(qc_header.qc),
    });

    axios
      .get(url, {
        headers: _headers,
      })
      .then((res) => {
        const response = {
          systemUid: "odm-party",
          items: res.data.map((resItem: any) => {
            return {
              value: resItem.id,
              label: resItem.id,
              config: {
                network_id: resItem.network_id,
              },
            };
          }),
        };
        resolve(response);
      })
      .catch((err) => {
        //FIXME: until debizium is fixed
        //reject(err)

        resolve({
          systemUid: "",
          items: [
            {
              id: "odm-party",
              label: "Crée2",
            },
          ],
        });
      });
  });
}
